import { FC } from "react";

const ClientInformationOption: FC<{ title: string, value?: React.ReactNode }> = ({ title, value }) =>
  <div className="text-sm grid font-medium gap-1">
    <div className="font-semibold">{title}</div>
    {value || '-'}
  </div>;

export default ClientInformationOption;